import { createSelector } from '@reduxjs/toolkit';
import { getOverbookedVariantIds } from 'common/api/frontend/inventory_new';
import { ReduxState } from 'services/types';

export const products = (state: ReduxState) => state.newRental.products ?? [];

export const rentalInfo = (state: ReduxState) => state.newRental.rentalInfo;

export const shoppers = (state: ReduxState) => state.newRental.shoppers;

export const startLocation = (state: ReduxState) => state.newRental.rentalInfo.startLocation;
export const endLocation = (state: ReduxState) => state.newRental.rentalInfo.endLocation;
export const reservationId = (state: ReduxState) => state.newRental.reservationId;

export const productAvailabilities = (state: ReduxState) => state.newRental.productAvailabilities;

export const overbookedVariantIds = createSelector(
	productAvailabilities,
	products,
	(productAvailabilities, products) => {
		return getOverbookedVariantIds(productAvailabilities, products);
	},
);

export const paymentMethod = createSelector(
	rentalInfo,
	(rentalInfo) => rentalInfo.pricing.paymentMethod,
);
export const isDurationManuallyChanged = (state: ReduxState) =>
	state.newRental.isDurationManuallyChanged;
